"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useEventValue_1 = __importDefault(require("./useEventValue"));
function useUnmountedEffect(cb) {
    var cbRef = useEventValue_1.default(cb);
    react_1.useEffect(function () { return function () { return cbRef.current(); }; }, [cbRef]);
}
exports.default = useUnmountedEffect;
